import cloudError from "../../../assets/cloud-error.webp";
import unauthorized from "../../../assets/access-denied.jpg";
import { BtnCustom } from "../../button/button";

const CardMessage = ({ title, type, textButton, callBackFunction, className, hasButton }) => {
	let imageSrc;
	switch (type) {
		case 0:
			imageSrc = cloudError;
			break;
		case 200:
			imageSrc = cloudError;
			break;
		case 403:
			imageSrc = unauthorized;
			break;
		default:
			imageSrc = unauthorized;
			break;
	}

	return (
		<div className={`flex flex-col justify-center items-center h-52 ${className}`}>
			{imageSrc && <img src={imageSrc} alt="Imagem de erro" className="w-40 h-40 bg-cover bg-center" />}
			<h1 className="text-sm">{title}</h1>
			{hasButton && (
				<BtnCustom
					text={textButton}
					className={"mt-4 btn btn-sm btn-primary w-44"}
					onClick={callBackFunction}
				/>
			)}
		</div>
	);
};

export default CardMessage;
